import { Moment } from 'moment';
import {
  FlightPassenger, FlightRoute,
  FlightSearchPayload,
  FlightSearchStore,
 } from '../../store/flightSearch/types';
import moment from 'moment';
import { useFlightSearchStore } from '../../store/flightSearch/flightSearchStore';

type PaxCounter = {
  numberOfAdults: number;
  numberOfChildren?: number;
  numberOfInfants?: number;
}

type FlightRouteArg = {
  DepartureDate?: Moment,
  ReturnDate?: Moment,
  OriginLocationCode?: string,
  DestinationLocationCode?: string,
  tripType: string
  multiCity?: FlightRoute[]
}
const generateFlightPassengersCount = ({
  numberOfAdults,
  numberOfChildren,
  numberOfInfants,
}: PaxCounter): FlightPassenger[] => {
  const payload = [
    {
      Code: 'ADT',
      Quantity: numberOfAdults,
    },
  ];

  if (numberOfChildren) {
    payload.push({
      Code: 'CHD',
      Quantity: numberOfChildren,
    });
  }

  if (numberOfInfants) {
    payload.push({
      Code: 'INF',
      Quantity: numberOfInfants,
    });
  }

  return payload;
};



// const generateFlightRoutes = (arg: FlightRouteArg): FlightRoute[] => {
//   const departureDate = arg.DepartureDate ? arg.DepartureDate.format('YYYY-MM-DD') : '';
//   const returnDate = arg.ReturnDate ? arg.ReturnDate.format('YYYY-MM-DD') : '';
//   let payload;

//   if (arg.tripType === 'multi_city' && arg?.multiCity?.length > 0) {
//     payload = arg.multiCity;
//   } else {
//     payload = [
//       {
//         DepartureDate: departureDate,
//         OriginLocationCode: arg.OriginLocationCode || '',
//         DestinationLocationCode: arg.DestinationLocationCode || '',
//       },
//     ];

//     if (arg.tripType === 'round_trip') {
//       payload.push({
//         DepartureDate: returnDate,
//         OriginLocationCode: arg.DestinationLocationCode || '',
//         DestinationLocationCode: arg.OriginLocationCode || '',
//       });
//     }
//   }

//   return payload;
// };

function resolveDepartureDate(date: any): string {
  if (!date) return "";

  const toFormatted = (d: any): string => {
    if (!d) return "";
    if (typeof d === "string") return d.split("T")[0];
    if (typeof d.format === "function") return d.format("YYYY-MM-DD"); // moment/dayjs object
    if (d instanceof Date) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    }
    return String(d);
  };

  // Range object: { from, to } — ensure `from` is not a function (moment has a .from() method)
  if (date.from && typeof date.from !== "function") return toFormatted(date.from);

  return toFormatted(date);
}

const generateFlightRoutes = (arg: FlightRouteArg): FlightRoute[] => {
  const departureDate = resolveDepartureDate(arg.DepartureDate);

  const returnDate = arg.DepartureDate?.to && typeof arg.DepartureDate.to !== "function"
    ? arg.DepartureDate.to
    : "";

  const isReturnFlight = Boolean(arg.DepartureDate?.to && typeof arg.DepartureDate.to !== "function");

  let payload;

  if (arg.tripType === "multi_city" && arg?.multiCity?.length! > 0) {
    payload = arg.multiCity;
  } else {
    payload = [
      {
        DepartureDate: departureDate,
        OriginLocationCode: arg.OriginLocationCode || "",
        DestinationLocationCode: arg.DestinationLocationCode || "",
      },
    ];

    if (isReturnFlight) {
      payload.push({
        DepartureDate: returnDate as string,
        OriginLocationCode: arg.DestinationLocationCode || "",
        DestinationLocationCode: arg.OriginLocationCode || "",
      });

    }
  }

  return payload as FlightRoute[];
};

export const buildFlightSearchPayload = (data: FlightSearchStore): FlightSearchPayload => {

  console.log("data in helper", data)
  const {
    Currency,
    From,
    pageSize,
    OrderbyFlightTime,
    OrderbyPrice,
    EnsureAgentUnicityForRoutes,
    FlightClass,
    numberOfAdults,
    numberOfChildren,
    numberOfInfants,
    DepartureDate,
    ReturnDate,
    DestinationLocationCode,
    OriginLocationCode,
    tripType,
    multiCity,
  } = data;

  const payload = {
    FlightRoutes: generateFlightRoutes({
      DepartureDate,
      ReturnDate,
      DestinationLocationCode,
      OriginLocationCode,
      tripType,
      multiCity,
    }),
    FlightClasses: [{
      Name: FlightClass,
    }],
    FlightPassengers: generateFlightPassengersCount({ numberOfAdults, numberOfChildren, numberOfInfants }),
    Currency,
    EnsureAgentUnicityForRoutes,
    OrderbyFlightTime,
    OrderbyPrice,
    pageSize,
    From,
  };

  return payload;
};


export const buildInternationalTripResults = (searchResults : FlightAggregateResultItem) => {
  return {
    TotalCount: searchResults.TotalCount,
    ResultList: [{
      TotalCount: searchResults.TotalCount,
      ResultList: searchResults.ResultList
    }]
  }
}

export const getDurationInMinutes = (data: string) => {
  const totalMinutes = data.split(":")
  const minutes = parseInt(totalMinutes[1].replace("m", ""));
  const hours = parseInt(totalMinutes[0].replace("h", ""));

  return (minutes + (hours * 60))
}

export const formatDisplayDate = (date: any): string => {
  if (!date) return "";

  // { from, to } range object — guard against moment's .from() method
  if (date.from && typeof date.from !== "function") {
    return moment(date.from).format("ddd, DD MMM");
  }

  // moment/dayjs object
  if (typeof date.format === "function") {
    return date.format("ddd, DD MMM");
  }

  // plain string
  if (typeof date === "string") {
    const m = moment(date);
    return m.isValid() ? m.format("ddd, DD MMM") : "";
  }

  return "";
};

export const formatReturnDisplayDate = (date: any): string => {
  if (!date) return "";

  // { from, to } range object — guard against moment's .from() method
  if (date.to && typeof date.to !== "function") {
    return moment(date.to).format("ddd, DD MMM");
  }

  // moment/dayjs object
  if (typeof date.format === "function") {
    return date.format("ddd, DD MMM");
  }

  // plain string
  if (typeof date === "string") {
    const m = moment(date);
    return m.isValid() ? m.format("ddd, DD MMM") : "";
  }

  return "";
};
